import { SortDirection } from '@components/design/migrated/Table/Sorting/types';
import axios from 'axios';
import { environment } from '@environments/environment';
import { ProductsCompareExport, ProductsCompareKpi, ProductsParam, SaleType, SortKeyLabels } from '@models/Products';
import { RequestPayloadArgumentObject } from '@pages/product-analyzer/Product';
import { constructRequest } from '@utils/serviceUtils/RequestFormatter';
import { getQueryClient } from '@queries/QueryClientWrapper';
import { throwApiError } from '@services/utils/ErrorHandlers';

const getCommonPayloadObject = (param: ProductsParam) => ({
  clientId: param.clientId,
  productType: param.productType,
  countryId: [param.countryId],
  productGroup: param.productGroup,
  periodType: param.periodType,
  period: param.period,
  comparisonPeriod: param.comparisonPeriod,
  appliedFilters: param.appliedFilters,
  kpi: SaleType.revenue,
  calculateRollingPeriod: true,
  itemIdList: param.itemIdList,
  isMarket: param.isMarket,
  page: undefined,
  size: undefined,
  sortBy: param.sortingKpi,
  sortDirection: SortDirection.desc,
  sortKey: SortKeyLabels.ABSOLUTE,
  comparisonGrowth: undefined,
});

export const getProductsCompare = async (param: ProductsParam): Promise<ProductsCompareKpi> => {
  let body: any;
  try {
    const qc = getQueryClient('products');
    const payload: RequestPayloadArgumentObject = getCommonPayloadObject(param);
    const queryKey = ['products-compare', payload] as const;
    const url = `${environment.baseUrl}/v2/products/compare-product-sales`;
    body = constructRequest(payload);

    return await qc.ensureQueryData<ProductsCompareKpi>({
      queryKey,
      queryFn: async ({ signal }) => {
        const { data } = await axios.post<ProductsCompareKpi>(url, body, { signal });
        return data;
      },
    });
  } catch (err: any) {
    // Delegated error handling; helper always throws. Added explicit throw for Sonar compliance.
    throwApiError(err, { excludedBrand: body?.excludedBrand }); // NOSONAR
  }
};

export const getProductsCompareExport = async (param: ProductsParam): Promise<ProductsCompareExport[]> => {
  let body: any;
  try {
    const qc = getQueryClient('products');
    const payload: RequestPayloadArgumentObject = {
      ...getCommonPayloadObject(param),
      exportCompareComparisonPeriodType: param.exportCompareComparisonType,
    } as RequestPayloadArgumentObject;
    const queryKey = ['products-compare-export', payload] as const;
    const url = `${environment.baseUrl}/v2/products/export-products-compare`;
    body = constructRequest(payload);

    return await qc.ensureQueryData<ProductsCompareExport[]>({
      queryKey,
      queryFn: async ({ signal }) => {
        const { data } = await axios.post<ProductsCompareExport[]>(url, body, { signal });
        return data;
      },
    });
  } catch (err: any) {
    // Delegated error handling; helper always throws. Added explicit throw for Sonar compliance.
    throwApiError(err, { excludedBrand: body?.excludedBrand }); // NOSONAR
  }
};
